type ParallelId = string|symbol;
export default class WorkerPromisify<T> {
    private worker: Worker;
    constructor(workerGetter: () => Worker) {
        this.worker = workerGetter();
    }

    // @ts-ignore
    onAnyResults(result: T, parallelId:ParallelId):void {
        throw new Error('not implemented');
    }

    postMessage(message: any, parallelIdGetter:() => ParallelId): Promise<T> {
        const self = this;

        return new Promise((resolve, reject) => {
            const mixedMessageData = {
                payload: message,
                parallelId: parallelIdGetter(),
            }
            function onError(event: ErrorEvent) {
                cleanup();
                reject(event.error || event);
            }
            function onMessage(event: MessageEvent) {
                if (event.data.parallelId === mixedMessageData.parallelId) {
                    // 当前scope的结束
                    cleanup();
                }

                if (event.data.result) {
                    self.onAnyResults(event.data.result as T, event.data.parallelId as ParallelId);
                }

                if (event.data.parallelId === parallelIdGetter()) {
                    if (event.data.error) {
                        reject(event.data.error);
                    } else {
                        resolve(event.data.result as T);
                    }
                }
            }
            const timeoutTimer = setTimeout(() => { // 15秒强制超时
                cleanup();
            }, 15 * 1000);

            function cleanup() {
                clearTimeout(timeoutTimer);
                self.worker.removeEventListener('message', onMessage);
                self.worker.removeEventListener('error', onError);
            }

            this.worker.addEventListener('message', onMessage);
            this.worker.addEventListener('error', onError);
            this.worker.postMessage(mixedMessageData);
        });
    }
}
